import { ComponentType as e } from "../../registries/types/propTypes.js";
const r = (n) => {
  const i = Array.isArray(n.amway_business_links) ? n.amway_business_links[0] : n.amway_business_links, a = i.items.map((s) => ({
    images: s.image.images,
    linkdata: {
      url: s.link.url,
      text: s.link.text,
      target: s.link.target
    }
  }));
  return {
    componentType: e.amway_business_links,
    title: i.display_title,
    quickLinksData: a
  };
};
export {
  r as default
};
//# sourceMappingURL=amway-business-link-transformer.js.map
